import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-performance.json";
import { getDataFilteredByRange } from "../portfolio/utils";
import { mapPayloadToMarketPerfomance } from "./utils";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { DatesRange } from "@/types/entity";
import type { PerformancePayload } from "@/types/market";
import type { Performance } from "@/types/performance";

type MarketDecadePerformanceParams = Partial<DatesRange> & {
  decade: string;
};

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  const uri = new RegExp("/carburate/market/decades/.+/performance/");
  mock.onGet(uri).reply(200, data);
}

export const getMarketDecadePerformance = async ({ decade }: MarketDecadePerformanceParams) => {
  const response = (await api.get(
    `/carburate/market/decades/${decade}/performance/`
  )) as PerformancePayload;
  return mapPayloadToMarketPerfomance(response);
};

export const getMarketDecadePerformanceQueryOptions = ({
  decade,
}: MarketDecadePerformanceParams) => {
  return queryOptions({
    queryKey: ["market", "decades", decade, "performance"],
    queryFn: () => getMarketDecadePerformance({ decade }),
  });
};

type UseMarketDecadePerformanceOptions = MarketDecadePerformanceParams & {
  queryConfig?: QueryConfig<typeof getMarketDecadePerformance>;
};

export const useMarketDecadePerformance = ({
  decade,
  from,
  queryConfig,
  to,
}: UseMarketDecadePerformanceOptions) => {
  let data: Performance;

  const {
    data: response,
    isSuccess,
    ...props
  } = useQuery({
    enabled: hasAccessToken(),
    ...getMarketDecadePerformanceQueryOptions({ decade }),
    ...queryConfig,
  });

  data = response!;
  if (isSuccess) {
    data = getDataFilteredByRange(data, from && to ? { from, to } : undefined);
  }

  return { data, isSuccess, ...props };
};
